import { UserOutlined } from '@ant-design/icons';
import { Avatar, Dropdown, Tooltip } from 'antd';
import { useQueryClient } from '@tanstack/react-query';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { PageURL } from '@router/pageURL';
import { useAuth } from '@providers/AuthProvider/AuthContext';
export const ProfileSettings = () => {
  const { signOut, email } = useAuth();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const logoutHandler = async () => {
    await signOut();

    queryClient.clear();
    await queryClient.invalidateQueries(['get-user']);

    navigate(PageURL.LOGIN);
  };

  return (
    <div className={'ml-2 flex items-center gap-3 text-white'}>
      {email}
      <Dropdown
        menu={{
          items: [
            {
              key: 'logout',
              label: <FormattedMessage id={'auth.logout.title'} />,
              onClick: logoutHandler,
            },
          ],
        }}
        trigger={['click']}
        placement={'bottomRight'}
        getPopupContainer={() => document.body}
        overlayStyle={{ zIndex: 1200 }}
      >
        <Tooltip title={'Open settings'} zIndex={1200}>
          <span className={'inline-flex cursor-pointer'}>
            <Avatar icon={<UserOutlined />} className={'bg-[#bdbdbd]'} />
          </span>
        </Tooltip>
      </Dropdown>
    </div>
  );
};
